<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb stays the same -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/tickets/ticket"
                class="btn btn-icon btn-sm active bg-primary text-white me-1"
              >
                <i class="ti ti-list-tree"></i>
              </router-link>
            </div>
          </div>

          <div class="me-2 mb-2">
            <button
              type="button"
              class="btn btn-white d-inline-flex align-items-center"
              @click="reload"
              :disabled="store.loading"
            >
              <i class="ti ti-refresh me-1"></i>Refresh
            </button>
          </div>

          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_ticket"
              class="btn btn-primary d-flex align-items-center"
              v-can="'Ticket.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Ticket
            </a>
          </div>

          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- KPI cards (numbers now dynamic) -->
      <div class="row">
        <div
          class="col-xl-3 col-md-6 d-flex"
          v-for="(kpi, index) in kpis"
          :key="index"
        >
          <div class="card flex-fill">
            <div class="card-body">
              <div class="row">
                <div class="col-6 d-flex">
                  <div class="flex-fill">
                    <div
                      class="border border-dashed rounded-circle d-inline-flex align-items-center justify-content-center p-1 mb-3"
                      :class="kpi.borderClass"
                    >
                      <span
                        class="avatar avatar-lg avatar-rounded"
                        :class="kpi.bgClass"
                      >
                        <i :class="kpi.icon"></i>
                      </span>
                    </div>
                    <p class="fw-medium fs-12 mb-1">{{ kpi.label }}</p>
                    <h4>{{ kpi.value }}</h4>
                  </div>
                </div>
                <div class="col-6 text-end d-flex">
                  <div class="d-flex flex-column justify-content-end align-items-end w-100">
                    <span class="badge bg-light text-dark border d-inline-flex align-items-center">
                      <i class="ti ti-database me-1"></i>Current Total
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters bar -->
      <div class="card">
        <div class="card-body p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
          >
            <div class="d-flex align-items-center flex-wrap gap-2">
              <h5 class="mb-0">Ticket List</h5>

              <!-- ✅ View Mode Toggle -->
              <div
                v-if="myEmployeeId"
                class="btn-group btn-group-sm ms-2"
                role="group"
              >
                <button
                  v-if="isStaff"
                  type="button"
                  class="btn"
                  :class="
                    viewMode === 'all' ? 'btn-primary' : 'btn-outline-primary'
                  "
                  @click="setViewMode('all')"
                >
                  All
                </button>

                <button
                  type="button"
                  class="btn"
                  :class="
                    viewMode === 'assigned'
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  "
                  @click="setViewMode('assigned')"
                >
                  Assigned to me
                </button>

                <button
                  type="button"
                  class="btn"
                  :class="
                    viewMode === 'created'
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  "
                  @click="setViewMode('created')"
                >
                  Created by me
                </button>
              </div>
            </div>

            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <!-- Priority -->
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Priority
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('priority', '')"
                      >Priority</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('priority', 'High')"
                      >High</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('priority', 'Low')"
                      >Low</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('priority', 'Medium')"
                      >Medium</a
                    >
                  </li>
                </ul>
              </div>

              <!-- Status -->
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Select Status
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('status', 'Open')"
                      >Open</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('status', 'On Hold')"
                      >On Hold</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('status', 'Reopened')"
                      >Reopened</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setFilter('status', 'Closed')"
                      >Closed</a
                    >
                  </li>
                </ul>
              </div>

              <div class="me-2">
                <input
                  v-model.trim="store.filters.search"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Search code, subject, requester"
                  @keyup.enter="reload"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- List of tickets -->
      <div class="row">
        <div class="col-xl-9 col-md-8">
          <div v-for="t in store.items" :key="t.id" class="card">
            <div
              class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
            >
              <h5 class="text-info fw-medium">
                {{ t.category?.name || "General" }}
              </h5>

              <div class="d-flex align-items-center">
                <span
                  class="badge d-inline-flex align-items-center me-2"
                  :class="priorityBadgeClass(t.priority)"
                >
                  <i class="ti ti-circle-filled fs-5 me-1"></i>{{ t.priority }}
                </span>

                <!-- ✅ NEW / Needs Reply -->
                <span v-if="hasNew(t)" class="badge bg-danger me-2">NEW</span>
                <span
                  v-if="needsMyReply(t)"
                  class="badge bg-warning text-dark me-2"
                >
                  Needs reply
                </span>

                <div v-can="'Ticket.Edit'">
                  <vue-select
                    :options="['Public', 'Private']"
                    :modelValue="t.visibility"
                    @update:modelValue="
                      (v) => store.update(t.id, { visibility: v })
                    "
                    placeholder="Visibility"
                  />
                </div>
              </div>
            </div>

            <div
              class="card-body"
              v-can="'Ticket.Read'"
              @click="
                $router.push({
                  path: '/tickets/tickets-details',
                  query: { id: t.id },
                })
              "
              style="cursor: pointer"
            >
              <div>
                <span class="badge badge-info rounded-pill mb-2">{{
                  t.code
                }}</span>

                <div class="d-flex align-items-center mb-2 flex-wrap gap-2">
                  <h5 class="fw-semibold me-2 mb-0">
                    <router-link
                      :to="{
                        path: '/tickets/tickets-details',
                        query: { id: t.id },
                      }"
                      v-can="'Ticket.Read'"
                    >
                      {{ t.subject }}
                    </router-link>
                  </h5>

                  <span
                    class="badge d-flex align-items-center"
                    :class="statusOutlineClass(t.status)"
                  >
                    <i class="ti ti-circle-filled fs-5 me-1"></i>{{ t.status }}
                  </span>
                </div>

                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <p class="d-flex align-items-center mb-0 me-2">
                    <img
                      :src="avatarFor(t.assignee)"
                      class="avatar avatar-xs rounded-circle me-2"
                      alt="img"
                    />
                    Assigned to
                    <span class="text-dark ms-1">
                      {{ fullName(t.assignee?.user) || "Unassigned" }}
                    </span>
                  </p>

                  <p class="d-flex align-items-center mb-0 me-2">
                    <i class="ti ti-calendar-bolt me-1"></i>Updated
                    {{ fromNow(t.updated_at) }}
                  </p>

                  <p class="d-flex align-items-center mb-0">
                    <i class="ti ti-message-share me-1"></i>
                    {{ t.visible_comments_count ?? t.comments_count ?? (t.comments?.length || 0) }} Comments
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-center mb-4"
            v-if="store.pagination.total > store.items.length"
          >
            <a
              href="javascript:void(0);"
              class="btn btn-primary"
              @click="loadMore"
            >
              <i class="ti ti-loader-3 me-1"></i>Load More
            </a>
          </div>
        </div>

        <!-- Right side -->
        <div class="col-xl-3 col-md-4">
          <!-- Categories -->
          <div class="card">
            <div class="card-header"><h4>Ticket Categories</h4></div>
            <div class="card-body p-0">
              <div class="d-flex flex-column">
                <div
                  v-for="c in sidebarCategories"
                  :key="c.name"
                  class="d-flex align-items-center justify-content-between border-bottom p-3"
                >
                  <a href="javascript:void(0);">{{ c.name }}</a>
                  <div class="d-flex align-items-center">
                    <span class="badge badge-xs bg-dark rounded-circle">{{
                      c.count
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Support Agents -->
          <div class="card">
            <div class="card-header"><h4>Support Agents</h4></div>
            <div class="card-body p-0">
              <div class="d-flex flex-column">
                <div
                  v-for="a in sidebarAgents"
                  :key="a.name"
                  class="d-flex align-items-center justify-content-between border-bottom p-3"
                >
                  <span class="d-flex align-items-center">
                    <img
                      :src="a.avatar"
                      class="avatar avatar-xs rounded-circle me-2"
                      alt="img"
                    />
                    {{ a.name }}
                  </span>
                  <div class="d-flex align-items-center">
                    <span class="badge badge-xs bg-dark rounded-circle">{{
                      a.count
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <tickets-modal
    :edit-item="editItem"
    @saved="reload"
    @cleared-edit="editItem = null"
  ></tickets-modal>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useTicketStore } from "@/stores/ticketStore";
import TicketsModal from "@/components/modal/tickets-modal.vue";
import { useTicketCategoryStore } from "@/stores/ticketCategoryStore";
import { useAuthStore } from "@/stores/authStore";
import avatar01 from "@/assets/img/profiles/avatar-01.jpg";
import avatar02 from "@/assets/img/profiles/avatar-02.jpg";
import avatar03 from "@/assets/img/profiles/avatar-03.jpg";
import avatar04 from "@/assets/img/profiles/avatar-04.jpg";
import userPlaceholder from "@/assets/img/users/user-01.jpg";

const title = "Tickets";
const text = "Employee";
const text1 = "Tickets";

const store = useTicketStore();
const catStore = useTicketCategoryStore();
const auth = useAuthStore();

const editItem = ref(null);

/* ---------- header ---------- */
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

/* ---------- auth/employee context ---------- */
const myEmployeeId = computed(() => auth.user?.employee?.id || null);
const isStaff = computed(
  () =>
    auth.can("Ticket.Edit") ||
    auth.can("Ticket.Delete") ||
    auth.can("Ticket.Write")
);

/* ---------- view mode toggle ---------- */
const viewMode = ref("assigned"); // assigned | created | all

function setViewMode(mode) {
  viewMode.value = mode;

  // reset
  store.filters.assignee_id = "";
  store.filters.requester_id = "";

  if (!myEmployeeId.value) return store.fetchAll({ page: 1 });

  if (mode === "assigned") store.filters.assignee_id = myEmployeeId.value;
  if (mode === "created") store.filters.requester_id = myEmployeeId.value;

  // only staff can use "all"
  if (mode === "all" && !isStaff.value) {
    store.filters.assignee_id = myEmployeeId.value;
    viewMode.value = "assigned";
  }

  store.fetchAll({ page: 1 });
}

/* ---------- NEW / last seen ---------- */
function seenKey(id) {
  return `ticket:last_seen:${id}`;
}
function lastSeen(id) {
  const v = localStorage.getItem(seenKey(id));
  return v ? Number(v) : 0;
}
function hasNew(t) {
  const updated = t?.updated_at ? new Date(t.updated_at).getTime() : 0;
  return updated > lastSeen(t.id);
}
function needsMyReply(t) {
  if (!myEmployeeId.value) return false;
  if (t.assignee_id !== myEmployeeId.value) return false;
  if (!["Open", "Reopened", "On Hold"].includes(t.status)) return false;
  return hasNew(t);
}

/* ---------- KPIs ---------- */
const kpis = computed(() => [
  {
    label: "New Tickets",
    value: store.pagination.total || 0,
    icon: "ti ti-ticket fs-20",
    borderClass: "border-primary",
    bgClass: "bg-primary-transparent",
  },
  {
    label: "Open Tickets",
    value: store.items.filter((t) => t.status === "Open").length,
    icon: "ti ti-folder-open fs-20",
    borderClass: "border-purple",
    bgClass: "bg-transparent-purple",
  },
  {
    label: "Solved Tickets",
    value: store.items.filter((t) => t.status === "Closed").length,
    icon: "ti ti-checks fs-20",
    borderClass: "border-success",
    bgClass: "bg-success-transparent",
  },
  {
    label: "Pending Tickets",
    value: store.items.filter((t) => ["On Hold", "Reopened"].includes(t.status))
      .length,
    icon: "ti ti-progress-alert fs-20",
    borderClass: "border-info",
    bgClass: "bg-info-transparent",
  },
]);

/* ---------- helpers ---------- */
function priorityBadgeClass(p) {
  return {
    "badge-danger": p === "High" || p === "Urgent",
    "badge-warning": p === "Medium",
    "badge-success": p === "Low",
  };
}
function statusOutlineClass(s) {
  return {
    "badge bg-outline-pink d-flex align-items-center": s === "Open",
    "badge bg-outline-warning d-flex align-items-center": s === "On Hold",
    "badge bg-outline-purple d-flex align-items-center": s === "Reopened",
    "badge bg-outline-success d-flex align-items-center": s === "Closed",
  };
}
function fullName(u) {
  if (!u) return "";
  return [u.first_name, u.last_name].filter(Boolean).join(" ");
}
function fromNow(iso) {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso || "-";
  }
}

/* ---------- sidebar ---------- */
const sidebarCategories = computed(() => {
  if (catStore.stats?.length) return catStore.stats;
  const map = {};
  (store.items || []).forEach((t) => {
    const name = t.category?.name || "General";
    map[name] = (map[name] || 0) + 1;
  });
  return Object.entries(map).map(([name, count]) => ({ name, count }));
});

function avatarFor() {
  return userPlaceholder;
}

const sidebarAgents = computed(() => {
  const map = {};
  (store.items || []).forEach((t) => {
    const name = fullName(t.assignee?.user) || "Unassigned";
    map[name] = (map[name] || 0) + 1;
  });

  const imgs = [avatar01, avatar02, avatar03, avatar04];

  return Object.entries(map).map(([name, count], i) => ({
    name,
    count,
    avatar: imgs[i % imgs.length],
  }));
});

/* ---------- filters ---------- */
function setFilter(key, val) {
  store.filters[key] = val;
  store.fetchAll({ page: 1 });
}

function loadMore() {
  const nextPage = (store.pagination.current_page || 1) + 1;
  store.fetchAll({ page: nextPage });
}

function reload() {
  store.fetchAll({ page: 1 }, { force: true });
}

watch(
  () => ({ ...store.filters }),
  () => {
    catStore.fetchStats({ ...store.filters });
  },
  { deep: true }
);

onMounted(async () => {
  // default view mode: staff => all, normal => created
  if (myEmployeeId.value) {
    setViewMode(isStaff.value ? "all" : "created");
  } else {
    await store.ensureList();
  }

  await catStore.ensureAll();
  await catStore.ensureStats({ ...store.filters });
});
</script>


